import * as Yup from "yup"
import { AcademicLevel, Campus, Email, FirstName, LastName, MobilePhoneRequired, Salutation, Consentement } from "services/validation"
import { atLeastOneProgram } from "../services/landingPages"

// Hors Paris, BMI__c est coché automatiquement : la règle "au moins un programme" ne bloque donc que Paris
const schema = Yup.object().shape({
  ...Consentement,
  rendezVous: Yup.string().required('Veuillez choisir un type de rendez-vous'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation,
    PGE__c: Yup.boolean(),
    BMI__c: Yup.boolean()
  }).test('at-least-one-program', '', atLeastOneProgram(['PGE__c', 'BMI__c'], 'lead.programmes'))
})

export default schema
